/**
 * Quiz "add all" CTA enhancement (control + Arm A + Arm B).
 *
 * Turns the "add all" buttons into:
 *   [UPPERCASE LABEL]
 *   [🛍  Add all N essentials · $total]   OR   [🛍  Add all N add-ons to bag]
 *   [subtext]
 *
 * Count is computed from the products the button actually adds (same scope as the
 * theme.js handlers) and only counts in-stock items — if a product's selected shade is
 * out of stock it drops off the count, and it comes back when an available shade is
 * picked. Purely presentational; the click handlers are untouched.
 */
(function () {
  // href -> presentation. scope 'section' = the button's own section block (essentials /
  // complete-your-look); scope 'all' = every visible result product (control #add-all).
  var CONFIG = {
    '#add-all-essentials': { scope: 'section', noun: 'essentials',      price: true,  label: 'Your full essentials set', sub: 'In your matched shades' },
    '#add-all-addons':     { scope: 'section', noun: 'add-ons',         price: false, label: 'Complete your look',       sub: 'In your matched shades' },
    '#add-all':            { scope: 'all',     noun: 'recommendations', price: true,  label: 'Complete your look',       sub: 'In your matched shades' }
  };
  var SELECTOR = 'a[href="#add-all"], a[href="#add-all-essentials"], a[href="#add-all-addons"]';

  function bagIcon() {
    return '<svg class="quiz-addall__icon" width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
      '<path d="M6.2 8h11.6l-.9 11a1 1 0 0 1-1 .9H8.1a1 1 0 0 1-1-.9L6.2 8Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
      '<path d="M9 8.5V6.8a3 3 0 0 1 6 0v1.7" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';
  }

  function numbersIn(text) {
    var m = (text || '').replace(/,/g, '').match(/\d+(\.\d+)?/g);
    return m ? m.map(parseFloat) : [];
  }
  function symbolIn(text) {
    // Match only an actual currency symbol, not words like "Regular"/"Sale" that appear
    // in the visually-hidden price labels.
    var m = (text || '').match(/[$£€¥₹]/);
    return m ? m[0] : '$';
  }
  function fmt(amount, symbol) {
    var rounded = Math.round(amount * 100) / 100;
    return symbol + (Number.isInteger(rounded) ? String(rounded) : rounded.toFixed(2));
  }

  // Is the currently selected shade on this card in stock? Reads the checked swatch
  // directly (data-variant JSON / data-is-soldout / the .disabled swatch class), since the
  // add button isn't always flipped to "Notify Me" for a programmatically selected shade.
  function selectedShadeAvailable(card) {
    var radio = card.querySelector('input[type="radio"][name="option-0"]:checked');
    if (!radio) return true; // product without shade options
    if (radio.getAttribute('data-is-soldout') === 'true') return false;
    var swItem = radio.closest('.product-swatches-options__item');
    if (swItem && swItem.classList.contains('disabled')) return false;
    var vj = radio.getAttribute('data-variant');
    if (vj) {
      try { var v = JSON.parse(vj); if (v && v.available === false) return false; } catch (e) {}
    }
    return true;
  }

  // Visible, addable (in-stock), deduped product cards within a scope.
  function addableCards(scope) {
    var seen = {};
    var out = [];
    var cards = scope.querySelectorAll('.featured-collection-grid__product');
    for (var i = 0; i < cards.length; i++) {
      var p = cards[i];
      if (window.getComputedStyle(p).display === 'none') continue;
      var addBtn = p.querySelector('button[name="add"]');
      if (!addBtn) continue;
      var st = window.getComputedStyle(addBtn);
      if (st.display === 'none' || addBtn.hasAttribute('disabled') || addBtn.classList.contains('sold-out')) continue;
      // Exclude when the selected shade itself is out of stock (count drops; picking an
      // available shade brings it back).
      if (!selectedShadeAvailable(p)) continue;
      var idInput = p.querySelector('[name=id]');
      if (!idInput || !idInput.value) continue;
      if (seen[idInput.value]) continue;
      seen[idInput.value] = true;
      out.push(p);
    }
    return out;
  }

  function priceOf(card) {
    var el = card.querySelector('.product-item__price');
    if (!el) return { amount: 0, symbol: '$' };
    var nums = numbersIn(el.textContent);
    // Last number so a struck compare-at price doesn't win over the sale price.
    return { amount: nums.length ? nums[nums.length - 1] : 0, symbol: symbolIn(el.textContent) };
  }

  function insertSibling(container, className, text, after) {
    var ref = after ? container.nextElementSibling : container.previousElementSibling;
    if (ref && ref.classList && ref.classList.contains(className)) {
      ref.textContent = text;
      return;
    }
    var p = document.createElement('p');
    p.className = className;
    p.textContent = text;
    container.parentNode.insertBefore(p, after ? container.nextSibling : container);
  }

  function enhance(btn) {
    var cfg = CONFIG[btn.getAttribute('href')];
    if (!cfg) return;

    var scope = cfg.scope === 'section'
      ? (btn.closest('.featured-collection-grid__content') || document)
      : (document.querySelector('.quiz-result-products') || document);

    var cards = addableCards(scope);
    if (!cards.length) return; // results not rendered yet (or nothing in stock)

    var count = cards.length;
    var text;
    if (cfg.price) {
      var total = 0, symbol = '$';
      cards.forEach(function (c) { var pr = priceOf(c); total += pr.amount; if (pr.symbol) symbol = pr.symbol; });
      text = 'Add all ' + count + ' ' + cfg.noun + ' · ' + fmt(total, symbol);
    } else {
      text = 'Add all ' + count + ' ' + cfg.noun + ' to bag';
    }

    btn.innerHTML = bagIcon() + '<span>' + text + '</span>';
    btn.classList.add('quiz-addall__btn');

    var container = btn.closest('.button-block__button') || btn.parentElement;
    if (!container) return;
    container.classList.add('quiz-addall');
    insertSibling(container, 'quiz-addall__label', cfg.label, false);
    insertSibling(container, 'quiz-addall__sub', cfg.sub, true);
  }

  function run() {
    var btns = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < btns.length; i++) enhance(btns[i]);
  }

  function schedule() { setTimeout(run, 150); setTimeout(run, 700); }

  if (document.readyState !== 'loading') schedule();
  else document.addEventListener('DOMContentLoaded', schedule);

  ['a[href="#see-result"]', 'a[href="#see-my-results"]'].forEach(function (sel) {
    var el = document.querySelector(sel);
    if (el) el.addEventListener('click', schedule);
  });

  // Recompute when a shade changes (in-stock count can change). Debounced and delayed so
  // it runs after custom-events.js toggles the add/notify button for the new variant.
  var reTimer;
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type="radio"][name="option-0"]')) {
      clearTimeout(reTimer);
      reTimer = setTimeout(run, 200);
    }
  });
})();
